
export class UsersPermissionState {

    userList = [];
    searchedUserList=[]
}